/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import VenmoPaymentButton from '@tcp/core/src/components/common/atoms/VenmoPaymentButton';
import ApplePaymentButton from '@tcp/core/src/components/common/atoms/ApplePaymentButton';
import LoaderSkelton from '@tcp/core/src/components/common/molecules/LoaderSkelton';
import RenderPerf from '@tcp/web/src/components/common/molecules/RenderPerf';
import { CALL_TO_ACTION_VISIBLE } from '@tcp/core/src/constants/rum.constants';
import BagPageUtils from '@tcp/core/src/components/features/CnC/BagPage/views/Bagpage.utils';
import ClickTracker from '@tcp/web/src/components/common/atoms/ClickTracker';
import AfterPayMessaging from '@tcp/core/src/components/common/organisms/AfterPayMessaging/container/AfterPayMessaging.container';
import { setLoyaltyLocation } from '@tcp/core/src/constants/analytics';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty.js';
import CARTPAGE_CONSTANTS from '@tcp/core/src/components/features/CnC/CartItemTile/CartItemTile.constants';
import BossConfirmationModal from '@tcp/core/src/components/features/CnC/BagPage/views/BossConfirmationModal.view';
import { isApplePayEligible, isCanada, parseBoolean, isClient } from '@tcp/core/src/utils/utils';
import { getSessionStorage, getBrand } from '@tcp/core/src/utils';
import AfterPayContainer from '@tcp/core/src/components/common/organisms/AfterPayPayment';
import { requireNamedOnlineModule } from '@tcp/core/src/utils/resourceLoader';
import pushEventToAdobeAnalytics from '@tcp/core/src/adobeAnalytics/adobe.utils';
import isAppleWalletSetUp from '../../Checkout/container/applepay.utils';
import Button from '../../../../common/atoms/Button';
import withStyles from '../../../../common/hoc/withStyles';
import style, { StyledDiv } from '../styles/AddedToBagActions.style';
import PayPalButton from '../../common/organism/PayPalButton';
import Row from '../../../../common/atoms/Row';
import Col from '../../../../common/atoms/Col';
import BodyCopy from '../../../../common/atoms/BodyCopy';
import { getLocator } from '../../../../../utils';
import ErrorMessage from '../../common/molecules/ErrorMessage';
import PaymentOptionsComp from './PaymentOptions.view';
import {
  renderCheckoutServerError,
  getClassForIsBagPageStickyHeader,
  getIdForIsBagPageStickyHeader,
  getApplePayEnabled,
  getPropTypes,
  getDefaultProps,
} from './AddedToBagActions.utils';
import AddedToBagActionsLabels, {
  CHECKOUT_BAGPAGE_LABELS,
  extendedPreOrderFooterMsg,
  GLOBAL_LABELS,
} from '../container/AddedToBagActions.labels';
import {
  GlobalGenericLabels,
  GLOBAL_GENERIC_LABELS,
  lblOr,
} from '../../../../../utils/labels/globalGeneric.labels';
import {
  GlobalAddToBagLabels,
  GLOBAL_ADD_TO_BAG_MODAL_LABELS,
} from '../../../../../utils/labels/globalAddedToBag.labels';
import FreeShippingProgressBar from '../../common/organism/FreeShippingProgressBar';
import BAGPAGE_CONSTANTS from '../../BagPage/BagPage.constants';
import AdyenPaymentContainer from '../../../../common/organisms/AdyenPayment';

class AddedToBagActions extends React.PureComponent {
  addedToBagActionsLabels = getLabelFromCopyOrFromTranslation(
    GLOBAL_LABELS,
    AddedToBagActionsLabels
  );

  constructor(props) {
    super(props);
    this.state = {
      paymentDisabled: true,
      isDefaultAppleVal: false,
      isAfterPayFlow: false,
    };
    this.onCheckoutScroll = this.onCheckoutScroll.bind(this);
    this.handlePayment = this.handlePayment.bind(this);
    this.myRef = React.createRef(null);
  }

  componentDidMount() {
    const {
      isPayPalHidden,
      showAddTobag,
      checkoutServerError,
      clearCheckoutServerError,
      isStickyCheckoutButtonEnabled,
      isMobile,
      router,
      spcBag,
    } = this.props;
    if (isPayPalHidden && showAddTobag && checkoutServerError) {
      clearCheckoutServerError({});
    }
    if (isStickyCheckoutButtonEnabled && isMobile) {
      window.addEventListener('scroll', this.onCheckoutScroll);
    }
    this.isDefaultApplePayEnabled();
    if (router?.prefetch && spcBag) router.prefetch('/SinglePageCheckout');
    if (isClient() && !window.isAfterPayLoaded) {
      requireNamedOnlineModule('afterPay').then(() => {
        window.isAfterPayLoaded = true;
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps?.isDefaultPayemnt !== this.props?.isDefaultPayemnt) {
      const isDefaultPayemnt = JSON.parse(JSON.stringify(this.props?.isDefaultPayemnt));
      if (isDefaultPayemnt && isDefaultPayemnt?.length > 0) {
        this.isDefaultApplePayEnabled();
      }
    }
    if (
      prevProps?.isDefaultAfterPayTestEnabled !== this.props?.isDefaultAfterPayTestEnabled ||
      prevProps?.authorizationKey !== this.props?.authorizationKey
    ) {
      this.isDefaultApplePayEnabled();
    }
  }

  componentWillUnmount() {
    const { isStickyCheckoutButtonEnabled, isMobile } = this.props;
    if (isStickyCheckoutButtonEnabled && isMobile) {
      window.removeEventListener('scroll', this.onCheckoutScroll);
    }
  }

  onCheckoutScroll = () => {
    const { handleCheckoutHidden } = this.props;
    const val = parseInt(this.myRef?.current?.getBoundingClientRect()?.top || 0, 10);
    if (-val > 0) {
      handleCheckoutHidden(true);
    } else {
      handleCheckoutHidden(false);
    }
  };

  getPaypalButton() {
    const {
      showAddTobag,
      containerId,
      isBagPageStickyHeader,
      isPayPalHidden,
      isPayPalEnabled,
      paypalButtonHeight,
      setIsPaypalBtnHidden,
      bagLoading,
      showCondensedHeader,
      isPayPalEnabledKillSwitch,
      isMixedOrder,
      containsExtendedOrder,
      isAdyenPaymentEnabled,
      isMiniBag,
      isMobile,
      cartOrderItems,
      setIsPaypalClicked,
      isBackPackAloneError,
      isBackPackOOS,
      bossGCAndPreOrderCase,
      verifyAllExpiredCoupons,
    } = this.props;
    let containerID = containerId;
    if (isBagPageStickyHeader) {
      containerID = 'paypal-button-container-bag-header';
    }
    if (showAddTobag && isPayPalHidden) {
      setIsPaypalBtnHidden(false);
    }
    if (isAdyenPaymentEnabled && cartOrderItems?.size > 0) {
      return (
        <AdyenPaymentContainer
          isBagPage
          heightValue={isMiniBag || (!isBagPageStickyHeader && !isMobile) ? 48 : 42}
          setIsPaypalClicked={setIsPaypalClicked}
          isMiniBag={isMiniBag}
          isBackPackAloneError={isBackPackAloneError}
          isBackPackOOS={isBackPackOOS}
          bossGCAndPreOrderCase={bossGCAndPreOrderCase}
          verifyAllExpiredCoupons={verifyAllExpiredCoupons}
          toggleMessageModal={this.toggleMessageModal}
        />
      );
    }

    return (
      !isPayPalHidden &&
      !bagLoading &&
      !containsExtendedOrder &&
      ((isPayPalEnabled && !isMixedOrder) || isPayPalEnabledKillSwitch) && (
        <div className={`${showAddTobag ? 'paypal-wrapper-atb' : 'paypal-wrapper'}`}>
          <div className="paypal-wrapper-content">
            <PayPalButton
              className="payPal-button"
              containerId={containerID}
              height={paypalButtonHeight}
              showCondensedHeader={showCondensedHeader}
            />
          </div>
        </div>
      )
    );
  }

  getHeaderPaypalButton() {
    const { isBagPageStickyHeader, isInternationalShipping } = this.props;
    if (!isInternationalShipping && isBagPageStickyHeader) {
      return this.getPaypalButton();
    }
    return null;
  }

  renderEstimatedTotal = () => {
    const { totalCount, cartValue, isShowBagSimplifiedHeader, currency, currencySymbol, isMobile } =
      this.props;
    const space = currency === 'USD' || currency === 'CAD' ? '' : ' ';

    return (
      totalCount > 0 &&
      isShowBagSimplifiedHeader &&
      isMobile && (
        <span className="estimated-tax-simplified-text">{`${currencySymbol}${
          (currency && space) || ''
        }${(Number(cartValue) || 0).toFixed(2)}`}</span>
      )
    );
  };

  // eslint-disable-next-line sonarjs/cognitive-complexity, complexity
  getCheckoutButton(value) {
    const { addedToBagModal } = this.addedToBagActionsLabels || {};
    const {
      handleCartCheckout,
      isEditingItem,
      setClickAnalyticsDataCheckout,
      cartOrderItems,
      isAddedToBag,
      isBagPage,
      isMiniBag,
      bagLoading,
      cartValue,
      isOptmisticAddToBagModal,
      isCartLoading,
      bossGCAndPreOrderCase,
      isStickyCheckoutButtonEnabled,
      isMobile,
      isCheckoutBannerHidden,
      checkOutInProgress,
      isBackPackAloneError,
      isBackPackOOS,
      verifyAllExpiredCoupons,
      containsExtendedOrder,
      isBagPageStickyHeader,
      isPLCCInstantCheckout,
    } = this.props;
    const paddingTop = {
      paddingTop: '20px',
    };
    const productsData = BagPageUtils.formatBagProductsData(cartOrderItems);
    return (
      <div
        ref={value ? this.myRef : ''}
        className={`${isMiniBag ? 'miniBag-CheckoutBtn-wrapper' : 'checkoutBtn-wrapper'}`}
      >
        {!bagLoading || isOptmisticAddToBagModal ? (
          <>
            <ClickTracker
              name="Gift_Services"
              onClick={() => {
                if (!isBackPackAloneError && !isBackPackOOS) {
                  setClickAnalyticsDataCheckout({
                    products: productsData,
                    eventName: 'checkout login click',
                    pageNavigationText: '',
                    listingSortList: '',
                    listingCount: '',
                    cartAmount: cartValue,
                  });
                  if (bossGCAndPreOrderCase || verifyAllExpiredCoupons) {
                    this.toggleMessageModal();
                    this.setAfterPayFlow(false);
                  } else {
                    handleCartCheckout({ isEditingItem, isAddedToBag, isBagPage, isMiniBag });
                  }
                  setLoyaltyLocation('checkout-popup');
                } else {
                  return null;
                }
                return null;
              }}
              className="checkoutBtnTracker"
            >
              <Button
                data-locator={getLocator('addedtobag_btncheckout')}
                className="checkout checkout-gym"
                disabled={isCartLoading}
                loading={checkOutInProgress}
                buttonVariation="fixed-width"
                fill="BLUE"
                onClick={() => {
                  setTimeout(() => {
                    pushEventToAdobeAnalytics('checkout_start', isMiniBag);
                    if (!isBackPackAloneError && !isBackPackOOS) {
                      pushEventToAdobeAnalytics('product_checkout', productsData);
                      setClickAnalyticsDataCheckout({
                        products: productsData,
                        eventName: 'checkout login click',
                        pageNavigationText: '',
                        listingSortList: '',
                        listingCount: '',
                        cartAmount: cartValue,
                      });
                      if (bossGCAndPreOrderCase || verifyAllExpiredCoupons) {
                        this.toggleMessageModal();
                        this.setAfterPayFlow(false);
                      } else {
                        handleCartCheckout({ isEditingItem, isAddedToBag, isBagPage, isMiniBag });
                      }
                    }
                    return null;
                  }, 0);
                }}
              >
                {renderLabel(addedToBagModal?.lbl_cta_checkout, 'lbl_cta_checkout')}
                {this.renderEstimatedTotal()}
              </Button>
            </ClickTracker>
            {isStickyCheckoutButtonEnabled &&
              !isCheckoutBannerHidden &&
              isMobile &&
              !isPLCCInstantCheckout &&
              !this.state.isDefaultAppleVal &&
              !isCanada() && (
                <BodyCopy
                  component="div"
                  color="black"
                  fontWeight="extrabold"
                  fontFamily="secondary"
                  fontSize="fs14"
                  className="checkout-divider"
                >
                  {renderLabel(
                    getLabelFromCopyOrFromTranslation(
                      `${GLOBAL_GENERIC_LABELS}.${lblOr}`,
                      GlobalGenericLabels
                    ),
                    'lbl_or'
                  )}
                </BodyCopy>
              )}
            {containsExtendedOrder && !isMiniBag && !isBagPageStickyHeader && (
              <BodyCopy
                fontFamily="secondary"
                component="span"
                fontSize="fs13"
                textAlign="center"
                customStyle={paddingTop}
              >
                {renderLabel(
                  getLabelFromCopyOrFromTranslation(
                    `${CHECKOUT_BAGPAGE_LABELS}.${extendedPreOrderFooterMsg}`,
                    AddedToBagActionsLabels
                  ),
                  'lbl_extended_preOrder_footer_msg'
                )}
              </BodyCopy>
            )}
          </>
        ) : (
          <div className="checkoutSkeleton">
            <LoaderSkelton />
          </div>
        )}
      </div>
    );
  }

  isDefaultApplePayEnabled = () => {
    const isAppleEligibleVal = isApplePayEligible();
    const {
      isDefaultApplePayAbTest,
      defaultPayment,
      isPaymentSectionSaved,
      isApplePayVisible,
      paymentId,
      isDefaultAfterPayTestEnabled,
      authorizationKey,
    } = this.props;
    const afterPaySS = parseBoolean(getSessionStorage('defaultAfterPay'));
    isAppleWalletSetUp(authorizationKey)?.then((res) => {
      if (res) {
        const isDefaultPayemnt = defaultPayment && JSON.parse(JSON.stringify(defaultPayment));
        const isPaymentPresent = isDefaultPayemnt
          ? isDefaultPayemnt?.length > 0
          : isPaymentSectionSaved;
        if (
          isDefaultApplePayAbTest &&
          (!isPaymentPresent || paymentId === 'APPLE_PAY') &&
          isAppleEligibleVal &&
          isApplePayVisible &&
          !isCanada() &&
          !(isDefaultAfterPayTestEnabled && afterPaySS)
        ) {
          this.setState({ isDefaultAppleVal: true });
        } else {
          this.setState({ isDefaultAppleVal: false });
        }
      } else {
        this.setState({ isDefaultAppleVal: false });
      }
    });
  };

  getApplePaymentButton() {
    const {
      isBagPageStickyHeader,
      bagLoading,
      getIsUpdateShippingCalled,
      setIsUpdateShippingCalled,
      isMobile,
      isAdyenApplePayBagPageEnabled,
      isAdyenApplePayBagPageVisibilityEnabled,
      orderType,
      isBackPackAloneError,
      isBackPackOOS,
      bossGCAndPreOrderCase,
      verifyAllExpiredCoupons,
    } = this.props;
    const containerID = isBagPageStickyHeader ? 'apple-button-container-bag-header' : '';
    const className =
      isBagPageStickyHeader && isAdyenApplePayBagPageEnabled
        ? 'apple-button-container-bag-header'
        : 'apple-wrapper';

    const heightValue = isBagPageStickyHeader || isMobile ? 40 : 45;

    return getApplePayEnabled(this.props) && this.state.isDefaultAppleVal ? (
      <>
        {bagLoading ? (
          <div className="apple-wrapper">
            <LoaderSkelton />
          </div>
        ) : (
          <div className="apple-wrapper">
            <div>{this.getCheckoutButton(true)}</div>
          </div>
        )}
      </>
    ) : (
      getApplePayEnabled(this.props) && (
        <>
          {bagLoading ? (
            <div className="apple-wrapper">
              <LoaderSkelton />
            </div>
          ) : (
            <div className={className}>
              {isAdyenApplePayBagPageEnabled &&
                isAdyenApplePayBagPageVisibilityEnabled &&
                isAdyenApplePayBagPageVisibilityEnabled.includes(orderType) && (
                  <AdyenPaymentContainer
                    isBagPage
                    heightValue={heightValue}
                    isApplePay={isAdyenApplePayBagPageEnabled}
                    isBackPackAloneError={isBackPackAloneError}
                    isBackPackOOS={isBackPackOOS}
                    bossGCAndPreOrderCase={bossGCAndPreOrderCase}
                    verifyAllExpiredCoupons={verifyAllExpiredCoupons}
                    toggleMessageModal={this.toggleMessageModal}
                  />
                )}
              {!isAdyenApplePayBagPageEnabled && (
                <ApplePaymentButton
                  className="apple-container"
                  isBagPage
                  containerId={containerID}
                  getIsUpdateShippingCalled={getIsUpdateShippingCalled}
                  setIsUpdateShippingCalled={setIsUpdateShippingCalled}
                />
              )}
            </div>
          )}
        </>
      )
    );
  }

  getVenmoEnabled() {
    const { isVenmoEnabled, isInternationalShipping, isUSSite, showVenmo } = this.props;
    return (
      isVenmoEnabled &&
      showVenmo &&
      !isInternationalShipping &&
      isUSSite &&
      !getApplePayEnabled(this.props)
    );
  }

  getVenmoPaymentButton() {
    const { handleCartCheckout, isEditingItem, bagLoading } = this.props;
    if (bagLoading) {
      return (
        <div className="venmo-wrapper">
          <LoaderSkelton />
        </div>
      );
    }

    if (this.getVenmoEnabled()) {
      return (
        <div className="venmo-wrapper">
          <VenmoPaymentButton
            className="venmo-container"
            onSuccess={() => handleCartCheckout(isEditingItem)}
            isBagPage
          />
        </div>
      );
    }
    return null;
  }

  getViewBagButton() {
    const {
      onClickViewBag,
      showAddTobag,
      enableKeepShoppingCTA,
      handleContinueShopping,
      isAddedToBag,
    } = this.props;
    const { addedToBagModal } = this.addedToBagActionsLabels || {};
    if (isAddedToBag) {
      return (
        <>
          {showAddTobag && (
            <div className="view-bag-container redesigned-bag-container sticky-action-btn">
              <Button
                onClick={onClickViewBag}
                data-locator={getLocator('addedtobag_btnviewbag')}
                className="redesigned-view-bag"
              >
                <BodyCopy
                  component="span"
                  fontWeight="extrabold"
                  fontFamily="secondary"
                  fontSize="fs14"
                  textAlign="center"
                >
                  {renderLabel(addedToBagModal.lbl_cta_viewBag, 'lbl_cta_viewBag')}
                </BodyCopy>
              </Button>
              <Button
                onClick={handleContinueShopping}
                buttonVariation="fixed-width"
                className="redesigned-keep-shopping"
                id={`brand-${getBrand()}`}
              >
                <BodyCopy
                  component="span"
                  fontWeight="extrabold"
                  fontFamily="secondary"
                  fontSize="fs14"
                  color="white"
                  className="keep-shopping-text"
                  textAlign="center"
                >
                  {renderLabel(addedToBagModal?.lbl_cta_keepShopping, 'lbl_cta_keepShopping')}
                </BodyCopy>
              </Button>
            </div>
          )}
        </>
      );
    }

    if (enableKeepShoppingCTA) {
      return (
        <>
          {showAddTobag && (
            <div className="view-bag-container">
              <Button
                onClick={handleContinueShopping}
                buttonVariation="fixed-width"
                className="keep-shopping"
              >
                <BodyCopy
                  component="span"
                  fontWeight="extrabold"
                  fontFamily="secondary"
                  fontSize="fs14"
                >
                  {renderLabel(addedToBagModal?.lbl_cta_keepShopping, 'lbl_cta_keepShopping')}
                </BodyCopy>
              </Button>
              <Button
                onClick={onClickViewBag}
                data-locator={getLocator('addedtobag_btnviewbag')}
                className="view-bag"
              >
                <BodyCopy
                  component="span"
                  color="white"
                  fontWeight="extrabold"
                  fontFamily="secondary"
                  fontSize="fs14"
                >
                  {renderLabel(addedToBagModal.lbl_cta_viewBag, 'lbl_cta_viewBag')}
                </BodyCopy>
              </Button>
            </div>
          )}
        </>
      );
    }
    return (
      <>
        {showAddTobag && (
          <Row className="view-bag-container">
            <Col colSize={{ medium: 8, large: 12, small: 6 }}>
              <Button
                onClick={onClickViewBag}
                data-locator={getLocator('addedtobag_btnviewbag')}
                className="view-bag"
              >
                <BodyCopy
                  component="span"
                  color="white"
                  fontWeight="extrabold"
                  fontFamily="secondary"
                  fontSize="fs14"
                >
                  {renderLabel(addedToBagModal.lbl_cta_viewBag, 'lbl_cta_viewBag')}
                </BodyCopy>
              </Button>
            </Col>
          </Row>
        )}
      </>
    );
  }

  renderPaymentButtons = () => {
    const {
      containsExtendedOrder,
      isExpressAfterpayEnabled,
      startExpressCheckoutHandler,
      modalInfo,
      getEstimatedTaxAction,
      calculatedEstimatedTax,
      cartHaveGCItem,
      bossGCAndPreOrderCase,
      isPayPalDisabled,
    } = this.props;
    if (!containsExtendedOrder) {
      return (
        <>
          {!isPayPalDisabled && this.getHeaderPaypalButton()}
          {isExpressAfterpayEnabled && !cartHaveGCItem && (
            <div className="after-pay-block">
              <AfterPayContainer
                className="after-pay-container"
                startExpressCheckoutHandler={startExpressCheckoutHandler}
                modalInfo={modalInfo}
                isExpressPayment
                singlePageCheckout
                getEstimatedTaxAction={getEstimatedTaxAction}
                calculatedEstimatedTax={calculatedEstimatedTax}
                bossGCAndPreOrderCase={bossGCAndPreOrderCase}
                toggelBossModal={this.toggleMessageModal}
                setAfterPayFlow={this.setAfterPayFlow}
              />
            </div>
          )}
          {this.getVenmoPaymentButton()}
          {this.getApplePaymentButton()}
        </>
      );
    }
    return null;
  };

  getPaymemtButtonsForStickyHeader = () => {
    const {
      isCheckoutBannerHidden,
      className,
      enableKeepShoppingCTA,
      isAddedToBag,
      isBagPageStickyHeader,
      isCartLoading,
      isPayPalDisabled,
    } = this.props;
    return (
      <>
        {isCheckoutBannerHidden && (
          <div className={className}>
            {this.getViewBagButton()}
            {!enableKeepShoppingCTA && !isAddedToBag && isCheckoutBannerHidden && (
              <>
                <Row
                  className={`checkout-button ${
                    isCheckoutBannerHidden ? 'sticky-checkout-button-new' : ''
                  } ${isBagPageStickyHeader ? 'checkout-button-bagHeader' : ''}`}
                  id={`${!isBagPageStickyHeader ? 'checkout-button-section' : ''}`}
                >
                  {this.renderAfterPayMessaging()}
                  <div
                    className={`${!isPayPalDisabled && 'paypal-venmo'} ${
                      isBagPageStickyHeader ? 'checkout-sticky-header' : ''
                    }`}
                  >
                    {!isPayPalDisabled && this.getPaypalButton()}
                    {this.renderPaymentButtons()}
                  </div>
                  {this.getCheckoutButton(false)}
                  {isCartLoading ? <div className="invisible-div" /> : null}
                  <RenderPerf.Measure name={CALL_TO_ACTION_VISIBLE} />
                </Row>
              </>
            )}
          </div>
        )}
      </>
    );
  };

  getPaypalButtonForStickyHeader = () => {
    const { isBagPageStickyHeader, isInternationalShipping, containsExtendedOrder } = this.props;
    if (!containsExtendedOrder)
      return !isInternationalShipping && !isBagPageStickyHeader && this.getPaypalButton();
    return null;
  };

  toggleMessageModal = () => {
    const { isModalOpen } = this.state;
    const { verifyAllExpiredCoupons } = this.props;
    this.setState({ isModalOpen: !isModalOpen }, () => {
      const couponContainer = document?.getElementById('coupon-container-new-design');

      if (verifyAllExpiredCoupons) {
        couponContainer?.scrollIntoView();
      }
    });
  };

  setAfterPayFlow = (value) => {
    this.setState({ isAfterPayFlow: value });
  };

  convertToShipToHome = () => {
    const { userDefaultStore, updateStoreItem, productItems } = this.props;
    const {
      itemInfo: { itemBrand, imagePath, fit, size, itemId, qty, color, wasPrice },
      miscInfo: { shipmentId, isOnlineOnly, TCPProductIndStore },
      productInfo: { productPartNumber, tcpStyleType, variant, variantNo, tcpStyleQty },
    } = productItems[0];
    const { ECOM } = CARTPAGE_CONSTANTS;
    try {
      if (productItems.length !== 0) {
        const itemDetails = {
          c_prodPartNo: productPartNumber,
          c_brand: itemBrand,
          c_TCPColor: color?.toString(),
          c_TCPStyleType: tcpStyleType,
          c_TCPimages: imagePath || '',
          c_TCPProductIndStore: TCPProductIndStore,
          c_fit: fit || null,
          c_size: size,
          c_variant: variant,
          productId: variantNo,
          itemId,
          quantity: qty.toString(),
          c_TCPStyleQTY: tcpStyleQty?.toString() || '',
          c_TCPWebOnlyFlagStore: isOnlineOnly,
          shipment_id: shipmentId,
          c_list_price: wasPrice,
        };
        const updPayload = {
          ...itemDetails,
          c_orderItemType: ECOM,
          c_fromStoreId: userDefaultStore?.basicInfo?.id,
        };
        updateStoreItem(updPayload, true);
        this.toggleMessageModal();
      }
    } catch (err) {
      return false;
    }
    return true;
  };

  getBOSSMessage = (bossAndPreOrder, bossAndGC, verifyAllExpiredCoupons, bossInEligible) => {
    const warningLabels = getLabelFromCopyOrFromTranslation(
      GLOBAL_ADD_TO_BAG_MODAL_LABELS,
      GlobalAddToBagLabels
    );
    let bossWarningMessage = '';
    if (bossAndPreOrder && bossAndGC) {
      bossWarningMessage = warningLabels.lbl_preorder_giftcard_warning;
    } else if (bossAndPreOrder) {
      bossWarningMessage = warningLabels.lbl_preorder_warning;
    } else if (bossAndGC) {
      bossWarningMessage = warningLabels.lbl_giftcard_warning;
    } else if (bossInEligible) {
      bossWarningMessage = warningLabels.lbl_boss_ineligible_warning;
    } else if (verifyAllExpiredCoupons) {
      bossWarningMessage =
        this.addedToBagActionsLabels.checkoutConfirmation?.lbl_checkoutmodal_couponError;
    }
    return bossWarningMessage;
  };

  handlePayment() {
    this.setState({ paymentDisabled: false });
  }

  renderButton() {
    const {
      isMiniBag,
      containsExtendedOrder,
      isStickyCheckoutButtonEnabled,
      isCheckoutBannerHidden,
      isMobile,
      isPLCCInstantCheckout,
    } = this.props;
    return (
      <>
        {this.state.isDefaultAppleVal && !isMiniBag && !containsExtendedOrder ? (
          <>
            {isStickyCheckoutButtonEnabled &&
              !isCheckoutBannerHidden &&
              isMobile &&
              !isPLCCInstantCheckout &&
              this.state.isDefaultAppleVal && (
                <BodyCopy
                  component="div"
                  color="black"
                  fontWeight="extrabold"
                  fontFamily="secondary"
                  fontSize="fs14"
                  className="checkout-divider"
                >
                  {renderLabel(
                    getLabelFromCopyOrFromTranslation(
                      `${GLOBAL_GENERIC_LABELS}.${lblOr}`,
                      GlobalGenericLabels
                    ),
                    'lbl_or'
                  )}
                </BodyCopy>
              )}
            <ApplePaymentButton
              className="apple-container"
              buttonClass="apple-pay-button-black"
              defaultApplepay="true"
            />
          </>
        ) : (
          this.getCheckoutButton(true)
        )}
      </>
    );
  }

  renderAfterPayMessaging() {
    const { isAddedToBag, orderBalanceTotal, containsExtendedOrder, isExpressAfterpayEnabled } =
      this.props;
    return (
      <>
        {!isAddedToBag && !containsExtendedOrder && !isExpressAfterpayEnabled && (
          <div className="afterpay-msg-section">
            <AfterPayMessaging
              isOrderThresholdEnabled
              offerPrice={orderBalanceTotal}
              isPriceBold
              disableForGC
              centered
            />
          </div>
        )}
      </>
    );
  }

  renderStickyHeader = ({
    isStickyCheckoutPaymentDisabled,
    paymentDisabled,
    isMobile,
    isStickyCheckoutButtonEnabled,
    isCheckoutBannerHidden,
    isBagPageStickyHeader,
    isAdyenPaymentEnabled,
    isPayPalDisabled,
  }) => {
    const noStickyHeader =
      isMobile &&
      ((isStickyCheckoutPaymentDisabled && paymentDisabled) ||
        (isStickyCheckoutButtonEnabled && isCheckoutBannerHidden));

    if (noStickyHeader) {
      return null;
    }

    const adyenPaymentClass = getApplePayEnabled(this.props)
      ? 'paypal-applePay-container-adyen'
      : 'paypal-venmo-container-adyen';
    const payPalClass = isAdyenPaymentEnabled ? adyenPaymentClass : 'paypal-venmo';
    return (
      <div
        className={`${!isPayPalDisabled && payPalClass} ${
          isBagPageStickyHeader ? 'checkout-sticky-header' : ''
        }`}
      >
        {(!isMobile || (isMobile && !this.state.isDefaultAppleVal)) &&
          !isPayPalDisabled &&
          this.getPaypalButtonForStickyHeader()}
        {this.renderPaymentButtons()}
        {isMobile &&
          this.state.isDefaultAppleVal &&
          !isPayPalDisabled &&
          this.getPaypalButtonForStickyHeader()}
      </div>
    );
  };

  getFreeShippingProgressBar = ({
    shipments,
    freeShippingThreshold,
    productTotal,
    dynamicShippingCharge,
    isBossEnabled,
    shippingMethodSelected,
    isMixedOrder,
    isFreeShippingProgressBarDisabled,
    isShippingOrder,
    isFreeShippingCouponApplied,
    freeShippingMessageForPromosEnabled,
    freeShippingPromoType,
  }) => {
    const shipmentsObject = shipments && JSON.parse(JSON.stringify(shipments));
    const shippingDetails = shipmentsObject?.filter(
      (shipment) => shipment?.c_fromStoreId === null
    )[0];

    const shippingMethodCodeSelected =
      shippingMethodSelected?.code || shippingDetails?.shippingMethod?.c_code;
    const shippingFreePercentage = (shippingDetails?.productTotal / freeShippingThreshold) * 100;
    const isShippingMethodApplicableForFreeShipping =
      BAGPAGE_CONSTANTS.FREE_SHIPMENT_CODES?.includes(shippingMethodCodeSelected);
    const showFreeShippingProgressBar =
      isShippingMethodApplicableForFreeShipping &&
      isShippingOrder &&
      !isFreeShippingProgressBarDisabled;
    return (
      showFreeShippingProgressBar &&
      freeShippingThreshold > 0 && (
        <FreeShippingProgressBar
          shipments={shipmentsObject}
          freeShippingThreshold={freeShippingThreshold}
          productTotal={productTotal}
          dynamicShippingCharge={dynamicShippingCharge}
          isBossEnabled={isBossEnabled}
          shippingFreePercentage={shippingFreePercentage}
          isMixedOrder={isMixedOrder}
          isFreeShippingCouponApplied={isFreeShippingCouponApplied}
          freeShippingMessageForPromosEnabled={freeShippingMessageForPromosEnabled}
          freeShippingPromoType={freeShippingPromoType}
          fromATBDrawer
        />
      )
    );
  };

  render() {
    const {
      className,
      isBagPageStickyHeader,
      checkoutServerError,
      venmoError,
      enableKeepShoppingCTA,
      isAddedToBag,
      isCartLoading,
      isCheckoutBannerHidden,
      isStickyCheckoutButtonEnabled,
      isStickyCheckoutPaymentDisabled,
      isMobile,
      bossAndPreOrder,
      bossAndGC,
      bossInEligible,
      verifyAllExpiredCoupons,
      isPLCCInstantCheckout,
      shipments,
      freeShippingThreshold,
      productTotal,
      dynamicShippingCharge,
      isBossEnabled,
      shippingMethodSelected,
      isMixedOrder,
      isFreeShippingProgressBarDisabled,
      isShippingOrder,
      isFreeShippingCouponApplied,
      freeShippingMessageForPromosEnabled,
      freeShippingPromoType,
      isInternationalShipping,
      isAdyenPaymentEnabled,
      isPayPalDisabled,
    } = this.props;
    const { paymentDisabled, isModalOpen, isAfterPayFlow } = this.state;
    const isApplePayEnabled = getApplePayEnabled(this.props);
    const canadaShippingError =
      checkoutServerError?.errorCode === '_ERR_INVALID_SHIPPING_METHOD_ID';

    return (
      <StyledDiv className={className}>
        {!isMobile &&
          isAddedToBag &&
          this.getFreeShippingProgressBar({
            shipments,
            freeShippingThreshold,
            productTotal,
            dynamicShippingCharge,
            isBossEnabled,
            shippingMethodSelected,
            isMixedOrder,
            isFreeShippingProgressBarDisabled,
            isShippingOrder,
            isFreeShippingCouponApplied,
            freeShippingMessageForPromosEnabled,
            freeShippingPromoType,
          })}
        {this.getViewBagButton()}
        {!enableKeepShoppingCTA && !isAddedToBag && (
          <>
            <Row
              className={`checkout-button ${getClassForIsBagPageStickyHeader(
                isBagPageStickyHeader
              )}`}
              id={`${getIdForIsBagPageStickyHeader(isBagPageStickyHeader)}`}
            >
              {this.renderStickyHeader({
                isStickyCheckoutPaymentDisabled,
                paymentDisabled,
                isMobile,
                isStickyCheckoutButtonEnabled,
                isCheckoutBannerHidden,
                isBagPageStickyHeader,
                isAdyenPaymentEnabled,
                isPayPalDisabled,
              })}
              {this.renderButton()}
              {isCartLoading ? <div className="invisible-div" /> : null}
              <RenderPerf.Measure name={CALL_TO_ACTION_VISIBLE} />
            </Row>
            {((!isStickyCheckoutButtonEnabled && !isStickyCheckoutPaymentDisabled) ||
              !paymentDisabled) &&
              (!isPLCCInstantCheckout || isInternationalShipping) &&
              this.renderAfterPayMessaging()}
            {paymentDisabled && isStickyCheckoutPaymentDisabled && (
              <PaymentOptionsComp
                handlePayment={this.handlePayment}
                isApplePayEnabled={isApplePayEnabled}
              />
            )}
          </>
        )}
        {this.getPaymemtButtonsForStickyHeader()}
        {(renderCheckoutServerError(checkoutServerError) || venmoError) && (
          <Row className="elem-mt-MED">
            <ErrorMessage
              error={venmoError || checkoutServerError.errorMessage}
              className="addBagActions-error"
              isEspot={canadaShippingError}
            />
          </Row>
        )}
        <BossConfirmationModal
          isOpen={isModalOpen}
          closeModal={this.toggleMessageModal}
          message={this.getBOSSMessage(
            bossAndPreOrder,
            bossAndGC,
            verifyAllExpiredCoupons,
            bossInEligible
          )}
          buttonsRequired={!verifyAllExpiredCoupons}
          convertItems={this.convertToShipToHome}
          isAfterPayFlow={isAfterPayFlow}
        />
      </StyledDiv>
    );
  }
}

AddedToBagActions.propTypes = getPropTypes;
AddedToBagActions.defaultProps = getDefaultProps;

export default withStyles(AddedToBagActions, style);
export { AddedToBagActions as AddedToBagActionsVanilla };
